module.exports = __webpack_public_path__ + "static/media/om.b6771181.svg";